module.exports = __webpack_public_path__ + "static/media/b2.2b9bf852.jpg";